import React from 'react';
import { Bell, Calendar, Trash2 } from 'lucide-react';
import { Reminder } from '../../types';
import { useTranslation } from '../../hooks/useTranslation';

interface RemindersListProps {
  reminders: Reminder[];
  onAddReminder: () => void;
  onDeleteReminder: (id: string) => void;
  formatDateFR: (date: string) => string;
}

export const RemindersList: React.FC<RemindersListProps> = ({
  reminders,
  onAddReminder,
  onDeleteReminder,
  formatDateFR
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white p-6 rounded-[2.5rem] border border-gray-100 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-sm font-black text-gray-900 uppercase tracking-widest flex items-center gap-2">
          <Bell size={14}/> {t('app:reminders.title')}
        </h3>
        <button 
          onClick={onAddReminder}
          className="text-[10px] font-black bg-gray-100 px-3 py-1.5 rounded-full"
        >
          {t('common:buttons.add')}
        </button>
      </div>
      
      {reminders.length > 0 ? (
        reminders.slice(0, 3).map(r => (
          <div key={r.id} className="flex justify-between items-center bg-gray-50 p-3 mb-2 rounded-2xl border border-gray-100">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center text-gray-500 shadow-sm">
                <Calendar size={14}/>
              </div>
              <div>
                <p className="text-[10px] font-bold text-indigo-600">{formatDateFR(r.date)}</p>
                <p className="text-xs font-bold">{r.title}</p>
              </div>
            </div>
            <button onClick={() => onDeleteReminder(r.id)}>
              <Trash2 size={14} className="text-gray-300 hover:text-red-500"/>
            </button>
          </div>
        ))
      ) : (
        <p className="text-center text-gray-300 text-xs py-2">
          {t('app:reminders.no_reminder')}
        </p>
      )}
    </div>
  );
};
